import { axiosApi as axios } from '../helpers/axiosApi';
import { getCookie } from './helpers';
const USER_API = "/accounts/users/";

export const getAllUsers = (params) => {
  return axios.get(USER_API,    {
      params: params,
      headers: {"Authorization": `Bearer ${getCookie('access')}`}
    }).then(res => {
    return res.data;
  });
};

export const addUser = (registry) => {
  return axios.post(USER_API, registry, {
    headers: {
      "Authorization": `Bearer ${getCookie('access')}`
    }
  }).then(res => {
    return res.data;
  });
};

export const updateUser = (id, body) => {
  return axios.put(`${USER_API}${id}/`, body, {
    headers: {
      "Authorization": `Bearer ${getCookie('access')}`
    }
  }).then(res => {
    return res.data;
  })
};

export const deleteUser = (id) => {
  return axios.delete(`${USER_API}${id}/`, {
    headers: {
      "Authorization": `Bearer ${getCookie('access')}`
    }
  }).then(res => {
    return res;
  })
};
